import { apigateway } from "../intances/apigateway"
import jwtDecode from "jwt-decode"
import { Cookies } from "react-cookie"

export const login = ({ username, password, tunnelData }) => {
  return apigateway(tunnelData)
    .post(
      "/uaa/oauth/token/multitenant",
      {},
      {
        params: {
          grant_type: "password",
          client_id: "pdi-simulation",
          client_secret: "",
          username: username,
          password: password
        }
      }
    )
    .then((res) => {
      resetTokenCookie()
      sessionStorage.setItem("user_token", res.data.access_token)
      setTokenCookie(res.data)
    })
    .catch((error) => {
      console.error("error", error.response.data)
      error.response.data.username = username
      throw error.response.data
    })
}

export const getUserToken = () => {
  return sessionStorage.getItem("user_token")
}

export const getUsername = () => {
  if (sessionStorage.getItem("user_token")) {
    let token = jwtDecode(sessionStorage.getItem("user_token"))
    return token.preferred_username
  } else {
    return null
  }
}

export const isUserConnected = () => {
  if (sessionStorage.getItem("user_token")) {
    let token = jwtDecode(sessionStorage.getItem("user_token"))
    return token?.exp && new Date().getTime() < token.exp * 1000
  } else {
    return false
  }
}

export function resetTokenCookie() {
  const cookies = new Cookies()
  const domain = process.env.REACT_APP_ENV === "local" ? "localhost" : ".evollis.com"

  cookies.remove("TOKEN_HEADER", { domain })
  cookies.remove("TOKEN_OPTIONS", { domain })
  cookies.remove("TOKEN", { domain })
  cookies.remove("TOKEN_PART_ONE", { domain })
  cookies.remove("TOKEN_PART_TWO", { domain })
}

export function setTokenCookie(data) {
  const cookies = new Cookies()
  const domain = process.env.REACT_APP_ENV === "local" ? "localhost" : ".evollis.com"

  const tokenSplitted = data.access_token?.split(".")

  if (tokenSplitted[1].length > 2000) {
    const tokenPartOne = tokenSplitted[1].substring(0, 1000)
    const tokenPartTwo = tokenSplitted[1].substring(1000)
    cookies.set("TOKEN_PART_ONE", tokenPartOne, { domain })

    cookies.set("TOKEN_PART_TWO", tokenPartTwo, { domain })
  } else {
    cookies.set("TOKEN", tokenSplitted[1], { domain })
  }

  cookies.set("TOKEN_HEADER", tokenSplitted[0], { domain })
  cookies.set("TOKEN_OPTIONS", tokenSplitted[2], { domain })
}
